import { ChangelogPage, getStaticProps as staticProps } from "@/components/changelog/ChangelogPage";

export const getStaticProps = staticProps("select");

export default ChangelogPage;
